import { InputFormField } from 'components/InputFormField';
import { Button } from 'components/Button';
import React from 'react';
import { iconWhiteTrash } from 'assets/icons';
import { CardContent } from './styles';
import { EncryptedFieldsProps, ResponsibleInputsProps } from './useDepartmentContacts';
import { FormikErrors, FormikTouched } from 'formik';
import { variablePhoneMask } from 'utils/masks';

interface ResponsibleInputsFieldsProps {
  name: string,
  inputsValues: ResponsibleInputsProps,
  errors?: FormikErrors<ResponsibleInputsProps>,
  touched?: FormikTouched<ResponsibleInputsProps>,
  handleChange: any,
  handleRemoveResponsible: any,
  encryptedFields?: EncryptedFieldsProps,
  handleDecrypt?: (d: string, f: 'phoneNumber' | 'email') => void,
}

export const ResponsibleInputsFields: React.FC<ResponsibleInputsFieldsProps> = ({
  name,
  inputsValues,
  errors,
  touched,
  handleChange,
  handleRemoveResponsible,
  encryptedFields,
  handleDecrypt,
}) => {
  return (
    <CardContent>
      <InputFormField
        name={`${name}.responsible`}
        label="Nome completo"
        marginBotton="0"
        block={true}
        value={inputsValues?.responsible}
        onChange={handleChange}
        error={touched?.responsible && !!errors?.responsible}
        mensageError="Nome inválido"
      />
      <InputFormField
        name={`${name}.email`}
        label="E-mail comercial"
        marginBotton="0"
        block={true}
        value={inputsValues?.email}
        onChange={handleChange}
        error={touched?.email && !!errors?.email}
        mensageError="E-mail inválido"
        isEncrypted={true}
        currentStateEncrypted={encryptedFields?.[name as keyof typeof encryptedFields].email.isEncrypted}
        readOnly={encryptedFields?.[name as keyof typeof encryptedFields].email.isEncrypted}
        animation={encryptedFields?.[name as keyof typeof encryptedFields].email.isLoading}
        onClick={() => handleDecrypt?.(name, 'email')}
      />
      <div className="card-last-item">
        <InputFormField
          name={`${name}.phoneNumber`}
          label="Telefone"
          marginBotton="0"
          block={true}
          value={inputsValues?.phoneNumber}
          onChange={handleChange}
          error={touched?.phoneNumber && !!errors?.phoneNumber}
          mask={variablePhoneMask}
          mensageError="Telefone inválido"
          isEncrypted={true}
          currentStateEncrypted={encryptedFields?.[name as keyof typeof encryptedFields].phoneNumber.isEncrypted}
          readOnly={encryptedFields?.[name as keyof typeof encryptedFields].phoneNumber.isEncrypted}
          animation={encryptedFields?.[name as keyof typeof encryptedFields].phoneNumber.isLoading}
          onClick={() => handleDecrypt?.(name, 'phoneNumber')}
        />
        <Button
          name={name}
          type="button"
          onlyIcon={true}
          icon={iconWhiteTrash} 
          typeBtn="danger"
          onClick={handleRemoveResponsible}
        />
      </div>
    </CardContent>
  )
}